import {
  AppBar,
  Box,
  Button,
  Container,
  Grid,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  styled,
} from "@mui/material";
import { t } from "i18next";
import { navigation } from "../context/navigation";
import useLayout from "../context/useLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import useSettings from "../../../hooks/useSettings";
export default function DashboardFooter() {
  const { active, handleActiveMainMenu } = useLayout();

  return (
    <>
      <DashboardFooterRoot >
        <StyledToolBar >
          <Container maxWidth={"xs"} sx={{ p: '0px !important' }}>
            <Grid container columns={12}>
              {navigation.map((nav, index) => {
                const isActive = active === nav.name
                return <Grid item xs={3} key={index}>
                  <StyledButton
                    className={`${nav.path.replaceAll('/', '')} ${isActive ? "active" : ""}`}
                    onClick={handleActiveMainMenu(nav)}>
                    <Typography variant="h6">{isActive ? `<${t(nav.name)}>` : `${t(nav.name)}`}</Typography>
                  </StyledButton>
                </Grid>
              })}
            </Grid>
          </Container>
        </StyledToolBar>
      </DashboardFooterRoot>
    </>
  );
}

const StyledButton = styled(Button)(({ theme }) => ({
  width: "100%",
  flexDirection: "column",
  background: "none !important",
  height: 60,
  position: 'relative',
  padding: '0px',
  transition: 'all 0.1s ease-in-out',
  border: '1px solid transparent',
  borderTop: '5px solid transparent',
  borderRadius: 0,
  marginTop: '-5px',
  '& .bg': {
    opacity: 0
  },
  '&.active ': {
    borderColor: '#8aeb5d !important',
    '& .MuiTypography-root': {
      color: '#8aeb5d !important'
    }
  }
}));

const DashboardFooterRoot = styled(AppBar)(({ theme }) => ({
  position: "fixed",
  top: 'unset',
  bottom: 0,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "top center",
  backgroundColor: "transparent",
  boxShadow: "none",
  minHeight: 50,
  zIndex: 97,
  borderTop: '1px dashed #8AEB5D',
  background: "#000"
}));

const StyledToolBar = styled(Toolbar)(({ theme }) => ({
  bottom: 0,
  borderRadius: "0rem",
  padding: "0px !important",
  height: 50,
  background: 'linear-gradient( transparent,rgba(0,0,0,0.8))'
}));
